const getMovieUrl = (routeMovie, currentLang) => {

    if (
        !routeMovie ||
        !routeMovie.hasOwnProperty('uri_list') ||
        !routeMovie.uri_list.hasOwnProperty(currentLang) ||
        !routeMovie.uri_list[currentLang]) {
        return null
    }
    return routeMovie.uri_list[currentLang]
}

export default getMovieUrl
